"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactUsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var envelope_svg_1 = __importDefault(require("../../assets/icons/envelope.svg"));
var phone_svg_1 = __importDefault(require("../../assets/icons/phone.svg"));
var support_svg_1 = __importDefault(require("../../assets/icons/support.svg"));
var send_generic_email_1 = require("../../api/calls/notification/send_generic_email");
var validateForm_1 = require("../../helpers/validateForm");
var main_1 = require("../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var ContactUsPage = function () {
    var _a, _b, _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    var canvasRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)({
        to: (_a = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _a !== void 0 ? _a : "",
        subject: "",
        from: "",
        template_id: (_b = process.env.CONTACT_SUPPORT_TEMPLATE_ID) !== null && _b !== void 0 ? _b : "",
        data: {
            name: "",
            message: "",
        },
    }), contactUsData = _d[0], setContactUsData = _d[1];
    var _e = (0, react_1.useState)(false), isLoadingContactButton = _e[0], setIsLoadingContactButton = _e[1];
    var customValidation = {
        from: {
            name: "contact email",
        },
    };
    var _f = (0, validateForm_1.validateForm)(contactUsData, customValidation), errors = _f.errors, isValid = _f.isValid;
    var _g = (0, validateForm_1.validateForm)(contactUsData.data), dataErrors = _g.errors, dataIsValid = _g.isValid;
    var sendContactUsEmail = function () {
        setIsLoadingContactButton(true);
        (0, send_generic_email_1.send_generic_email)({
            to: contactUsData.to,
            subject: contactUsData.subject,
            from: contactUsData.from,
            template_id: contactUsData.template_id,
            data: {
                name: contactUsData.data.name,
                message: contactUsData.data.message,
            },
        }).then(function (response) {
            setIsLoadingContactButton(false);
            dispatch((0, main_1.setMainModal)({ title: response.success ? "Done!" : "Something went wrong!", messages: [response.message] }));
        });
    };
    (0, react_1.useEffect)(function () {
        var canvas = canvasRef.current;
        if (canvas) {
            var context = canvas.getContext("2d");
            context.fillStyle = "#000000";
            context.filter = "blur(0px)";
            context.shadowColor = "#ff0000";
            context.shadowBlur = 0;
            context.fillRect(0, 0, context.canvas.width, 10);
        }
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
                    react_1.default.createElement("div", { className: "flex flex-col items-center" },
                        react_1.default.createElement("div", { className: "w-[400px] md:w-[600px] lg:w-[800px] \n                flex flex-col gap-y-4 p-8" },
                            react_1.default.createElement("div", { className: "py-20 flex flex-col items-center gap-8" },
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Contact our sales team", size: "3xlarge", textColor: "text-white", center: true }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "If you need our help, have questions about how to use the platform or are experiencing technical difficulties, please do not hesitate to contact us.", size: "medium", textColor: "text-white", center: true })),
                            react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-white shadow-md shadow-[#404040]", variant: "filled", addPadding: false },
                                react_1.default.createElement("div", { className: "p-8" },
                                    react_1.default.createElement("div", { className: "grid gap-4\n                      grid-cols-1 lg:grid-cols-2" },
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Your name", value: contactUsData.data.name, onChange: function (v) {
                                                return setContactUsData(__assign(__assign({}, contactUsData), { data: __assign(__assign({}, contactUsData.data), { name: v }) }));
                                            }, errorText: dataErrors.name }),
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Contact email", value: contactUsData.from, onChange: function (v) {
                                                return setContactUsData(__assign(__assign({}, contactUsData), { from: v }));
                                            }, errorText: errors.from }),
                                        react_1.default.createElement("div", { className: "lg:col-span-2" },
                                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Subject", value: contactUsData === null || contactUsData === void 0 ? void 0 : contactUsData.subject, onChange: function (v) {
                                                    return setContactUsData(__assign(__assign({}, contactUsData), { subject: v }));
                                                }, errorText: errors.subject })),
                                        react_1.default.createElement("div", { className: "lg:col-span-2" },
                                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Your message", lines: 8, value: (_c = contactUsData === null || contactUsData === void 0 ? void 0 : contactUsData.data) === null || _c === void 0 ? void 0 : _c.message, onChange: function (v) {
                                                    return setContactUsData(__assign(__assign({}, contactUsData), { data: __assign(__assign({}, contactUsData.data), { message: v }) }));
                                                }, errorText: dataErrors.message }))),
                                    react_1.default.createElement("div", { className: "text-xs pt-8 pb-4" },
                                        "By submitting this form you agree to our ",
                                        react_1.default.createElement("span", { className: "underline" }, "Terms & Conditions"),
                                        ", and our",
                                        " ",
                                        react_1.default.createElement("span", { className: "underline" }, "Privacy Policy"),
                                        " which explains how we may collect, use and disclose your personal information, including to third parties."),
                                    react_1.default.createElement("div", { className: "flex flex-row justify-start" },
                                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Contact sales", backgroundColor: "bg-primary", enabled: isValid && dataIsValid, loading: isLoadingContactButton, onClick: function () { return sendContactUsEmail(); } })))))),
                    react_1.default.createElement("div", { className: " my-20" },
                        react_1.default.createElement("div", { className: "grid grid-cols-3 gap-4" }, sampleContactDisplay.map(function (display, index) {
                            return (react_1.default.createElement("div", { className: "flex flex-col items-center", key: index },
                                react_1.default.createElement("img", { src: display.img }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: display.title, size: "xlarge", textColor: "text-secondary" }),
                                react_1.default.createElement(doshx_controls_web_1.LabelControl, { className: "min-h-[50px] mb-8", label: display.description, size: "small", textColor: "text-secondary", center: true }),
                                display.link && react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: display.link, size: "medium", textColor: "text-primary" }),
                                display.button && react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: display.button, size: "small", textColor: "text-white", backgroundColor: "bg-primary" })));
                        }))))),
            react_1.default.createElement("div", { className: "absolute top-0 w-full -z-10" },
                react_1.default.createElement("div", { className: "h-72 bg-secondary" }),
                react_1.default.createElement("div", { className: "-mt-[1px]" },
                    react_1.default.createElement("svg", { viewBox: "0 0 20 1.5", xmlns: "http://www.w3.org/2000/svg" },
                        react_1.default.createElement("path", { d: "M 0 0 L 20 0 Q 10 3 0 0", fill: "bg-secondary" })))))));
};
exports.ContactUsPage = ContactUsPage;
var sampleContactDisplay = [
    {
        img: envelope_svg_1.default,
        title: "Email us",
        description: "Email us for general queries, including marketing and partnership opportunities.",
        link: (_a = process.env.CONTACT_SUPPORT_EMAIL_ADDRESS) !== null && _a !== void 0 ? _a : "",
    },
    {
        img: phone_svg_1.default,
        title: "Call us",
        description: "Call us to speak to a member of our team. We are always happy to help.",
        link: (_b = process.env.CONTACT_SUPPORT_PHONE_NUMBER) !== null && _b !== void 0 ? _b : "",
    },
    { img: support_svg_1.default, title: "Support", description: "Check out helpful resources, FAQs and developer tools." },
];
